import { Component, Inject } from '@angular/core';
import { CMPS_DIALOG_DATA, CmpsDialogRef } from '@cmps/ng-uikit';

import { TrendDialogMode } from '../../scorecard-mi2/trend-dialog';
import { CoachingTrendData } from '../models/coaching-trend-data.model';
import { TranslationKeyMap } from '../my-coaching-card.i18n';

@Component({
    selector: 'cmps-trend-view-dialog',
    templateUrl: './trend-view-dialog.component.html',
    host: {
        '[class.cmps-trend-view-dialog--performance-data]':
            '_trendData?.mode === _trendDialogMode.PERFORMANCE_DATA',
    },
})
export class CmpsTrendViewDialogComponent {
    /** @private */ _i18n = TranslationKeyMap;
    private readonly _trendDialogMode = TrendDialogMode;

    constructor(
        public readonly _dialogRef: CmpsDialogRef<
            CmpsTrendViewDialogComponent,
            any
        >,
        @Inject(CMPS_DIALOG_DATA) /** @private */
        readonly _trendData: CoachingTrendData,
    ) {}

    /** @private */
    _onCloseClick(): void {
        this._dialogRef.close();
    }
}
